import React from 'react';
import {
	Autocomplete,
	Grid,
	IconButton,
	TextareaAutosize,
	TextField,
	Tooltip,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentBias } from '../../actions/biases';
import { handleSuccess, sortSizes } from '../../helpers/utils';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { useEffect } from 'react';
import { Text } from '../orders/NewBiasForm4';
import { LEFT_RIGHT_MIDDLE_OPTIONS } from '../utils/lists';

export const BiasPartForm = ({
	order,
	handleClose,
	type,
	colors = [],
	sizes = [],
	setEmbroideryDone,
	setStampedDone,
	setSizesDone,
	globalUnits,
	setSummary,
}) => {
	const [sizesForm, setSizesForm] = useState([]);
	const [message, setMessage] = useState('');
	const { currentBias } = useSelector((state) => state.biases);
	const dispatch = useDispatch();

	// Embroidery & Stamped
	const [backEmbroidery, setBackEmbroidery] = useState('Ninguno');
	const [frontEmbroidery, setFrontEmbroidery] = useState('Ninguno');
	const [sleevesEmbroidery, setSleevesEmbroidery] = useState('Ninguno');
	const [embroideryType, setEmbroideryType] = useState('Ninguno');
	const [embroideryColor, setEmbroideryColor] = useState('---');
	const [measuresEmbroidery, setMeasuresEmbroidery] = useState('');
	const [notesEmbroidery, setNotesEmbroidery] = useState('');
	const [backStamped, setBackStamped] = useState('Ninguno');
	const [frontStamped, setFrontStamped] = useState('Ninguno');
	const [sleevesStamped, setSleevesStamped] = useState('Ninguno');
	const [stampedType, setStampedType] = useState('Ninguno');
	const [stampedColor, setStampedColor] = useState('---');
	const [measuresStamped, setMeasuresStamped] = useState('');
	const [notesStamped, setNotesStamped] = useState('');

	useEffect(() => {
		if (type === 'Bordado') {
			setBackEmbroidery(currentBias?.back_embroidery || 'Ninguno');
			setFrontEmbroidery(currentBias?.front_embroidery || 'Ninguno');
			setSleevesEmbroidery(currentBias?.sleeves_embroidery || 'Ninguno');
			setEmbroideryType(currentBias?.embroidery_type || 'Ninguno');
			setEmbroideryColor(currentBias?.embroidery_color || '---');
			setMeasuresEmbroidery(currentBias?.measures_embroidery || '');
			setNotesEmbroidery(currentBias?.notes_embroidery || '');
		} else if (type === 'Estampado') {
			setBackStamped(currentBias?.back_stamped || 'Ninguno');
			setFrontStamped(currentBias?.front_stamped || 'Ninguno');
			setSleevesStamped(currentBias?.sleeves_stamped || 'Ninguno');
			setStampedType(currentBias?.stamped_type || 'Ninguno');
			setStampedColor(currentBias?.stamped_color || '---');
			setMeasuresStamped(currentBias?.measures_stamped || '');
			setNotesStamped(currentBias?.notes_stamped || '');
		} else if (type === 'Tallas') {
			setSizesForm(currentBias?.subbiases || []);
		}
	}, [currentBias]);

	const handleSubmit = () => {
		if (type === 'Bordado') {
			dispatch(
				setCurrentBias({
					// Embroidery
					...currentBias,
					back_embroidery: backEmbroidery,
					front_embroidery: frontEmbroidery,
					sleeves_embroidery: sleevesEmbroidery,
					embroidery_type: embroideryType,
					embroidery_color: embroideryColor,
					measures_embroidery: measuresEmbroidery,
					notes_embroidery: notesEmbroidery,
				})
			);
			setEmbroideryDone(true);
			handleSuccess('El bordado se agregó correctamente');
		} else if (type === 'Estampado') {
			dispatch(
				setCurrentBias({
					// Printing
					...currentBias,
					back_stamped: backStamped,
					front_stamped: frontStamped,
					sleeves_stamped: sleevesStamped,
					stamped_type: stampedType,
					stamped_color: stampedColor,
					measures_stamped: measuresStamped,
					notes_stamped: notesStamped,
				})
			);
			setStampedDone(true);
			handleSuccess('El estampado se agregó correctamente');
		} else if (type === 'Tallas') {
			dispatch(
				setCurrentBias({
					// Printing
					...currentBias,
					subbiases: sizesForm,
				})
			);
			setSizesDone(true);
			handleSuccess('Las tallas se agregaron correctamente');

			if (order?.type === 'QUO') {
				setSummary((old) => ({ ...old, subbiases: sizesForm }));
			}
		}
		// reset();
		handleClose();
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	// Form
	const [units, setUnits] = useState('');
	const [size, setSize] = useState(null);

	// Handle add garment size
	const handleAddSize = () => {
		if (size) {
			if (!sizesForm.map((item) => item.size).includes(size)) {
				if (parseInt(units) > 0) {
					let counter = 0;
					sizesForm.forEach((item) => (counter += item.units));
					if (counter + parseInt(units) <= parseInt(globalUnits)) {
						const currentSize = sizes?.find(
							(item) => item.name === size
						);
						setSizesForm(
							sortSizes(
								[
									...sizesForm,
									{
										units: parseInt(units),
										price: currentSize?.price || 0,
										size,
										percentage:
											currentSize?.percentage || 0,
									},
								],
								'size'
							)
						);
						setUnits('');
						setSize(null);
					} else {
						setMessage(
							'La suma total rebasa las unidades del pedido.'
						);
					}
				} else {
					setMessage('Deben ser más de 0 unidades.');
				}
			} else {
				setMessage('Esa talla ya se escogió, selecciona otra.');
			}
		} else {
			setMessage('Selecciona una talla');
		}
		setTimeout(() => {
			setMessage('');
		}, 3000);
	};

	return (
		<>
			{type === 'Bordado' && (
				<Grid container spacing={2} className='mt-3'>
					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={backEmbroidery}
							onChange={(_, value) => {
								setBackEmbroidery(value);
							}}
							options={LEFT_RIGHT_MIDDLE_OPTIONS}
							renderInput={(params) =>
								TextFieldComponent(params, 'Espalda')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={frontEmbroidery}
							onChange={(_, value) => {
								setFrontEmbroidery(value);
							}}
							options={LEFT_RIGHT_MIDDLE_OPTIONS}
							renderInput={(params) =>
								TextFieldComponent(params, 'Frente')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={sleevesEmbroidery}
							onChange={(_, value) => {
								setSleevesEmbroidery(value);
							}}
							options={[
								'Ninguno',
								'Izquierda',
								'Derecha',
								'Ambos',
							]}
							renderInput={(params) =>
								TextFieldComponent(params, 'Mangas')
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={embroideryType}
							onChange={(_, value) => {
								setEmbroideryType(value);
							}}
							options={[
								'Ninguno',
								'Bordado en blanco',
								'A canutillo',
								'Bordado directo',
								'Directo a la prenda',
								'Tipo parche',
								'Ambos',
								'De perlas, abalorios y lentejuelas',
								'Bordado plano',
								'Cordoncillo',
							]}
							renderInput={(params) =>
								TextFieldComponent(params, 'Tipo de bordado')
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={embroideryColor}
							onChange={(_, value) => {
								setEmbroideryColor(value);
							}}
							options={colors.map((color) => color.name)}
							renderInput={(params) =>
								TextFieldComponent(params, 'Color')
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							required
							fullWidth
							label='Medidas'
							value={measuresEmbroidery}
							onChange={({ target }) =>
								setMeasuresEmbroidery(target.value)
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextareaAutosize
							value={notesEmbroidery}
							onChange={({ target }) =>
								setNotesEmbroidery(target.value)
							}
							aria-label='minimum height'
							minRows={5}
							variant='standard'
							placeholder='Comentarios para el bordado (opcional)'
							style={{
								width: '100%',
								borderRadius: '8px',
								height: 100,
								fontFamily: 'Arial',
								fontSize: '17px',
								marginTop: '-5px',
								padding: '10px',
								borderColor: '#E1DEDD',
							}}
						/>
					</Grid>
				</Grid>
			)}
			{type === 'Estampado' && (
				<Grid container spacing={2} className='mt-1'>
					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={backStamped}
							onChange={(_, value) => {
								setBackStamped(value);
							}}
							options={LEFT_RIGHT_MIDDLE_OPTIONS}
							renderInput={(params) =>
								TextFieldComponent(params, 'Espalda')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={frontStamped}
							onChange={(_, value) => {
								setFrontStamped(value);
							}}
							options={LEFT_RIGHT_MIDDLE_OPTIONS}
							renderInput={(params) =>
								TextFieldComponent(params, 'Frente')
							}
						/>
					</Grid>

					<Grid item xs={4}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={sleevesStamped}
							onChange={(_, value) => {
								setSleevesStamped(value);
							}}
							options={[
								'Ninguno',
								'Izquierda',
								'Derecha',
								'Ambos',
							]}
							renderInput={(params) =>
								TextFieldComponent(params, 'Mangas')
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={stampedType}
							onChange={(_, value) => {
								setStampedType(value);
							}}
							options={[
								'Ninguno',
								'Directo',
								'Tintes de tina',
								'Azufre',
								'Pigmentos orgánicos',
								'Reactivo',
								'Tintes dispersos',
								'Tintes Ácidos',
								'Azoico',
								'Básico',
								'Tintes de oxidación',
								'Tintes desarrollados',
								'Tintes mordientes',
								'Abrillantadores ópticos/fluorescentes',
								'Tintes solventes',
							]}
							renderInput={(params) =>
								TextFieldComponent(params, 'Tintas')
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<Autocomplete
							required
							style={{ marginTop: '-17px' }}
							fullWidth
							value={stampedColor}
							onChange={(_, value) => {
								setStampedColor(value);
							}}
							options={colors.map((color) => color.name)}
							renderInput={(params) =>
								TextFieldComponent(params, 'Color')
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							required
							fullWidth
							label='Medidas'
							value={measuresStamped}
							onChange={({ target }) =>
								setMeasuresStamped(target.value)
							}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextareaAutosize
							value={notesStamped}
							onChange={({ target }) =>
								setNotesStamped(target.value)
							}
							aria-label='minimum height'
							minRows={5}
							variant='standard'
							placeholder='Comentarios para el estampado (opcional)'
							style={{
								width: '100%',
								borderRadius: '8px',
								height: 100,
								fontFamily: 'Arial',
								fontSize: '17px',
								marginTop: '-5px',
								padding: '10px',
								borderColor: '#E1DEDD',
							}}
						/>
					</Grid>
				</Grid>
			)}

			{type === 'Tallas' && (
				<>
					<Grid container spacing={2} className='mt-1'>
						<Grid item xs={12}>
							<Text
								text={`Cantidad de tallas al momento: ${sizesForm.reduce(
									(sum, { units }) => sum + units,
									0
								)}`}
								variant='p'
							/>
						</Grid>
						<Grid item xs={5}>
							<Autocomplete
								required
								style={{ marginTop: '-17px' }}
								fullWidth
								value={size}
								onChange={(_, value) => {
									setSize(value);
								}}
								options={sortSizes(sizes, 'name').map(
									({ name }) => name
								)}
								renderInput={(params) =>
									TextFieldComponent(params, 'Tallas')
								}
							/>
						</Grid>

						<Grid item xs={5}>
							<TextField
								required
								type='number'
								fullWidth
								label='Unidades'
								value={units}
								onChange={({ target }) =>
									setUnits(target.value)
								}
								onKeyDown={({ key }) => {
									if (key === 'Enter') {
										handleAddSize();
									}
								}}
							/>
						</Grid>

						<Grid item xs={2}>
							{/* Confirm button */}
							<Tooltip title='Agregar'>
								<LoadingButton
									fullWidth
									size='large'
									variant='text'
									onClick={handleAddSize}
								>
									<AddIcon />
								</LoadingButton>
							</Tooltip>
						</Grid>
					</Grid>
					{message.length > 0 && (
						<p style={{ color: 'red', margin: '10px 0' }}>
							{message}
						</p>
					)}
					<ol style={{ margin: '20px 0 0 0' }}>
						{sizesForm.length > 0 &&
							sizesForm.map(({ units, size }, i) => (
								<li key={`Size-${i}`}>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
										}}
									>
										<div>
											<b>Unidades: </b> {units}
											{', '}
											<b>Talla: </b> {size}
										</div>
										<IconButton
											style={{ margin: '-8px 0 0 10px' }}
											onClick={() => {
												const newSizes =
													sizesForm.filter(
														(item) =>
															item.size !== size
													);
												setSizesForm(newSizes);
											}}
										>
											<ClearIcon />
										</IconButton>
									</div>
								</li>
							))}
					</ol>
				</>
			)}

			{/* Buttons */}
			<Grid container spacing={2} className='mt-1'>
				<Grid item xs={6}>
					{/* Cancel button */}
					<LoadingButton
						fullWidth
						size='large'
						color='error'
						onClick={() => {
							handleClose();
							// dispatch(resetBiases());
						}}
						variant='contained'
						loading={false}
					>
						Cancelar
					</LoadingButton>
				</Grid>

				<Grid item xs={6}>
					{/* Confirm button */}
					<LoadingButton
						fullWidth
						size='large'
						// style={{ backgroundColor: '#143f6c' }}
						variant='contained'
						// loading={isLoading}
						type='submit'
						disabled={type === 'Tallas' && sizesForm.length === 0}
						onClick={handleSubmit}
					>
						Guardar
					</LoadingButton>
				</Grid>
			</Grid>
		</>
	);
};
